import React, { useState } from 'react';
import styles from './AgentCard.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import moment from 'moment';
import Button from 'component/atom/forms/button/Button';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import { useDelete } from 'hooks/useDelete';
import { Agent } from 'hooks/endpoints';
import NewConnection from '../new-connection/NewConnection';
import { usePost } from 'hooks/usePost';
import { useNavigate } from 'react-router-dom';
import Tooltip from 'component/Custom/tooltip/Tooltip';

const AgentCard = ({ item, refetch }) => {
  const [deleteAgentModal, setDeleteAgentModal] = useState(false);
  const [isDisconnect, setIsDisconnect] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const { mutate: deleteAgent, isPending: isPendingDelete } = useDelete({
    onSuccessToast: 'Agent Deleted',
    toastType: 'add',
  });
  const { mutate: disconnectSystem, isPending: isPendingDisconnect } = usePost({
    onSuccessToast: 'System diconnected successfully',
    toastType: 'add',
  });

  const { mutate: connectSystem, isPending: isPendingconnect } = usePost({
    onSuccessToast: 'System connected successfully',
    toastType: 'add',
  });

  const handleDelete = () => {
    deleteAgent(
      {
        url: Agent.deleteAgentApi(item?.id),
      },
      {
        onSuccess: () => {
          refetch();
          setDeleteAgentModal(false);
        },
      }
    );
  };

  const handleConnect = () => {
    connectSystem(
      {
        url: Agent.connectAgent(item?.id),
      },
      {
        onSuccess: () => {
          refetch();
        },
      }
    );
  };

  const handleDisconnect = () => {
    disconnectSystem(
      {
        url: Agent.disconnectAgent(item?.id),
      },
      {
        onSuccess: () => {
          refetch();
          setIsDisconnect(false);
        },
      }
    );
  };
  const isConnected = item.connectionStatus !== 2;

  return (
    <div>
      <div
        className={styles['agent-card']}
        onClick={() => navigate(`/bot/agent/${item.id}`)}
      >
        <div className={styles['agent-card-header']}>
          <span className={styles['title']}>{item?.agentName}</span>
          <div className={styles['actions']}>
            <Tooltip content='Edit' className={styles['tooltip']}>
              <SvgWithBranding
                onClick={(e) => {
                  e.stopPropagation();
                  setIsEdit(true);
                }}
                type='edit'
                className={styles['action-icon']}
              />
            </Tooltip>
            <Tooltip content='Delete' className={styles['tooltip']} red={true}>
              <SvgWithBranding
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteAgentModal(true);
                }}
                type='delete2'
                className={styles['action-icon']}
              />
            </Tooltip>
          </div>
        </div>
        <div className={styles['action-card-body']}>
          <div className={styles['items-container']}>
            <div className={styles['body-item']}>
              <span className={styles['key']}>System Type</span>
              <span className={styles['value']}>{item?.connectionName}</span>
            </div>
            <div className={styles['body-item']}>
              <span className={styles['key']}>Base URL</span>
              <span className={styles['value']}>{item?.baseURL}</span>
            </div>
            <div className={styles['body-item']}>
              <span className={styles['key']}>Created at</span>
              <span className={styles['value']}>
                {moment(item?.createdAt).format('DD/MM/YYYY')}
              </span>
            </div>
          </div>
          <Button
            className={styles['connection-btn']}
            label={isConnected ? 'Disconnect' : 'Connect'}
            variant={isConnected ? 'danger-rev' : 'primary'}
            type='connect'
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (isConnected) {
                setIsDisconnect(true);
              } else {
                handleConnect();
              }
            }}
            isLoading={
              !isConnected && (isPendingDisconnect || isPendingconnect)
            }
          />
        </div>
      </div>
      <ConfirmationModal
        isOpen={deleteAgentModal}
        onClose={() => setDeleteAgentModal(false)}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Delete' }}
        text='Delete System Connection'
        subText='This will permanently remove all associated actions, conditions, and configurations. This action cannot be undone.'
        isLoading={isPendingDelete}
      />
      <ConfirmationModal
        isOpen={isDisconnect}
        onClose={() => setIsDisconnect(false)}
        onSubmit={handleDisconnect}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Disconnect' }}
        text='Disconnect System?'
        subText={`This will disconnect AiDucator from ${item?.connectionName}, limiting its access to data and may affect chatbot performance. 
This change is reversible.`}
        isLoading={isPendingDisconnect}
      />
      <NewConnection
        isOpen={isEdit}
        onClose={() => setIsEdit(false)}
        agentItem={item}
        refetch={refetch}
        setAgentItem={() => {}}
      />
    </div>
  );
};

export default AgentCard;
